<template>
  <table class="m-table FamilyForm">
    <tbody>
      <tr>
        <th colspan="2">名前</th>
        <td colspan="5"><input type='text' v-model="family.f_name" placeholder="姓" @keypress.self.prevent.13></td>
        <td colspan="5"><input type='text' v-model="family.l_name" placeholder="名" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2" class="req">かな</th>
        <td colspan="5"><input type='text' required v-model="family.f_name_kana" placeholder="せい" @keypress.self.prevent.13></td>
        <td colspan="5"><input type='text' required v-model="family.l_name_kana" placeholder="めい" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">続柄</th>
        <td colspan="10"><multiselect @select="select" v-model="watch.relationship" :options="relationship" label="name" :searchable="false" :show-labels="false" placeholder="続柄"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2">郵便番号</th>
        <td colspan="4"><input type='text' v-model="family.zip" @keyup="getYubin" placeholder="0000000" @keypress.self.prevent.13></td>
        <th colspan="2" class="req">都道府県</th>
        <td colspan="4"><multiselect @select="select" v-model="watch.pref" :options="prefs" label="name" :searchable="true" :show-labels="false" placeholder="都道府県"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2" class="req">住所</th>
        <td colspan="5"><input type='text' required v-model="family.address1" placeholder="市区町村・番地" @keypress.self.prevent.13></td>
        <td colspan="5"><input type='text' v-model="family.address2" placeholder="建物名・部屋番号" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2" class="req">携帯TEL</th>
        <td colspan="4"><input type='text' required maxlength="11" minlength="10" v-model="family.tel1" placeholder="携帯TEL" @keypress.self.prevent.13></td>
        <th colspan="2">固定TEL</th>
        <td colspan="4"><input type='text' maxlength="11" minlength="10" v-model="family.tel2" placeholder="固定TEL" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">FAX</th>
        <td colspan="10"><input type='text' v-model="family.fax" placeholder="FAX" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">MAIL1</th>
        <td colspan="4"><input type='text' v-model="family.mail" placeholder="PC" @keypress.self.prevent.13></td>
        <th colspan="2">MAIL2</th>
        <td colspan="4"><input type='text' v-model="family.mail2" placeholder="SP" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">指導種類(1人指導・2人同時指導)</th>
        <td colspan="4"><multiselect @select="select" v-model="watch.guidance_type" :options="guidance_type" label="name" :searchable="false" :show-labels="false" placeholder="指導種類(1人指導・2人同時指導)"></multiselect></td>
        <th colspan="2">家族構成</th>
        <td colspan="4"><input v-model="family.structure" placeholder="家族構成" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">件口</th>
        <td colspan="4"><multiselect @select="select" v-model="watch.unit" :options="unit" label="name" :searchable="false" :show-labels="false" placeholder="件口"></multiselect></td>
        <th colspan="2">勤め先連絡先</th>
        <td colspan="4"><input v-model="family.workplace_contact" placeholder="勤め先連絡先" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">優先連絡先</th>
        <td colspan="4"><multiselect @select="select" v-model="watch.preferred_contact" :options="preferred_contact" label="name" :searchable="false" :show-labels="false" placeholder="優先連絡先"></multiselect></td>
        <th colspan="2">連絡曜日時間帯</th>
        <td colspan="4"><input v-model="family.contact_timezone" placeholder="連絡曜日時間帯" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2" class="req">退会日</th>
        <td colspan="10"><input type="text" maxlength="10" minlength="10" v-model="family.withdrawal_date" placeholder="退会日" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">備考1</th>
        <td colspan="4"><textarea v-model="family.note1" placeholder="備考1"></textarea></td>
        <th colspan="2">備考2</th>
        <td colspan="4"><textarea v-model="family.note2" placeholder="備考2"></textarea></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
let jsonp = require('jsonp')
export default {
  props: {
    family: Object,
    watch: Object
  },
  data () {
    return {
    }
  },
  computed: {
    relationship () {
      return this.$store.getters['families/relationship']
    },

    guidance_type () {
      return this.$store.getters['families/guidance_type']
    },

    unit () {
      return this.$store.getters['families/unit']
    },

    preferred_contact () {
      return this.$store.getters['families/preferred_contact']
    },

    prefs () {
      return this.$store.getters.prefs.reverse()
    }
  },
  methods: {
    select (selectedOption, id) {
      // console.log(selectedOption)
    },

    getYubin (e) {
      let that = this
      // console.log(e)
      const value = e.target.value
      if (value.length > 5 && that.family.address1 === '') {
        jsonp('http://zipcloud.ibsnet.co.jp/api/search?zipcode=' + value, null, function (err, data) {
          if (err) {
            // error
            console.error(err.message)
          } else {
            // success
            console.log(data)
            if (data.results[0].address1 === '北海道') {
              that.watch.pref = { name: '1. 北海道', id: 1 }
            } else if (data.results[0].address1 === '青森県') {
              that.watch.pref = { name: '2. 青森県', id: 2 }
            } else if (data.results[0].address1 === '秋田県') {
              that.watch.pref = { name: '3. 秋田県', id: 3 }
            } else if (data.results[0].address1 === '岩手県') {
              that.watch.pref = { name: '4. 岩手県', id: 4 }
            } else if (data.results[0].address1 === '山形県') {
              that.watch.pref = { name: '5. 山形県', id: 5 }
            } else if (data.results[0].address1 === '宮城県') {
              that.watch.pref = { name: '6. 宮城県', id: 6 }
            } else if (data.results[0].address1 === '福島県') {
              that.watch.pref = { name: '7. 福島県', id: 7 }
            } else if (data.results[0].address1 === '栃木県') {
              that.watch.pref = { name: '8. 栃木県', id: 8 }
            } else if (data.results[0].address1 === '山梨県') {
              that.watch.pref = { name: '9. 山梨県', id: 9 }
            } else if (data.results[0].address1 === '群馬県') {
              that.watch.pref = { name: '10. 群馬県', id: 10 }
            } else if (data.results[0].address1 === '茨城県') {
              that.watch.pref = { name: '11. 茨城県', id: 11 }
            } else if (data.results[0].address1 === '千葉県') {
              that.watch.pref = { name: '12. 千葉県', id: 12 }
            } else if (data.results[0].address1 === '埼玉県') {
              that.watch.pref = { name: '13. 埼玉県', id: 13 }
            } else if (data.results[0].address1 === '東京都') {
              that.watch.pref = { name: '14. 東京都', id: 14 }
            } else if (data.results[0].address1 === '神奈川県') {
              that.watch.pref = { name: '15. 神奈川県', id: 15 }
            } else if (data.results[0].address1 === '静岡県') {
              that.watch.pref = { name: '16. 静岡県', id: 16 }
            } else if (data.results[0].address1 === '長野県') {
              that.watch.pref = { name: '17. 長野県', id: 17 }
            } else if (data.results[0].address1 === '愛知県') {
              that.watch.pref = { name: '18. 愛知県', id: 18 }
            } else if (data.results[0].address1 === '岐阜県') {
              that.watch.pref = { name: '19. 岐阜県', id: 19 }
            } else if (data.results[0].address1 === '新潟県') {
              that.watch.pref = { name: '20. 新潟県', id: 20 }
            } else if (data.results[0].address1 === '富山県') {
              that.watch.pref = { name: '21. 富山県', id: 21 }
            } else if (data.results[0].address1 === '石川県') {
              that.watch.pref = { name: '22. 石川県', id: 22 }
            } else if (data.results[0].address1 === '福井県') {
              that.watch.pref = { name: '23. 福井県', id: 23 }
            } else if (data.results[0].address1 === '滋賀県') {
              that.watch.pref = { name: '24. 滋賀県', id: 24 }
            } else if (data.results[0].address1 === '京都府') {
              that.watch.pref = { name: '25. 京都府', id: 25 }
            } else if (data.results[0].address1 === '三重県') {
              that.watch.pref = { name: '26. 三重県', id: 26 }
            } else if (data.results[0].address1 === '和歌山県') {
              that.watch.pref = { name: '27. 和歌山県', id: 27 }
            } else if (data.results[0].address1 === '奈良県') {
              that.watch.pref = { name: '28. 奈良県', id: 28 }
            } else if (data.results[0].address1 === '大阪府') {
              that.watch.pref = { name: '29. 大阪府', id: 29 }
            } else if (data.results[0].address1 === '兵庫県') {
              that.watch.pref = { name: '30. 兵庫県', id: 30 }
            } else if (data.results[0].address1 === '鳥取県') {
              that.watch.pref = { name: '31. 鳥取県', id: 31 }
            } else if (data.results[0].address1 === '島根県') {
              that.watch.pref = { name: '32. 島根県', id: 32 }
            } else if (data.results[0].address1 === '岡山県') {
              that.watch.pref = { name: '33. 岡山県', id: 33 }
            } else if (data.results[0].address1 === '広島県') {
              that.watch.pref = { name: '34. 広島県', id: 34 }
            } else if (data.results[0].address1 === '山口県') {
              that.watch.pref = { name: '35. 山口県', id: 35 }
            } else if (data.results[0].address1 === '高知県') {
              that.watch.pref = { name: '36. 高知県', id: 36 }
            } else if (data.results[0].address1 === '徳島県') {
              that.watch.pref = { name: '37. 徳島県', id: 37 }
            } else if (data.results[0].address1 === '香川県') {
              that.watch.pref = { name: '38. 香川県', id: 38 }
            } else if (data.results[0].address1 === '愛媛県') {
              that.watch.pref = { name: '39. 愛媛県', id: 39 }
            } else if (data.results[0].address1 === '福岡県') {
              that.watch.pref = { name: '40. 福岡県', id: 40 }
            } else if (data.results[0].address1 === '佐賀県') {
              that.watch.pref = { name: '41. 佐賀県', id: 41 }
            } else if (data.results[0].address1 === '長崎県') {
              that.watch.pref = { name: '42. 長崎県', id: 42 }
            } else if (data.results[0].address1 === '熊本県') {
              that.watch.pref = { name: '43. 熊本県', id: 43 }
            } else if (data.results[0].address1 === '宮崎県') {
              that.watch.pref = { name: '44. 宮崎県', id: 44 }
            } else if (data.results[0].address1 === '大分県') {
              that.watch.pref = { name: '45. 大分県', id: 45 }
            } else if (data.results[0].address1 === '鹿児島県') {
              that.watch.pref = { name: '46. 鹿児島県', id: 46 }
            } else if (data.results[0].address1 === '沖縄県') {
              that.watch.pref = { name: '47. 沖縄県', id: 47 }
            }
            that.family.address1 = data.results[0].address2 + data.results[0].address3
          }
        })
      }
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang='scss' scoped>
.req {
  /* background: #dffbef; */
  background: #41b883;
}
table {
  border-spacing: 0;
  width: 100%;
  border-top: solid 1px #ddd;
  tr {
    th {
      /* border-bottom: solid 1px #ddd; */
      /* background: #f4f4f4; */
      background: #37474f;
      /* color: #333; */
      color: #fbfbfb;
      padding: .5rem;
      font-weight: normal;
      font-size: .85rem;
    }
    td {
      border-bottom: solid 1px #ddd;
      border-right: solid 1px #ddd;
      input, textarea {
        outline: 0;
        border: none;
        width: 100%;
        padding: .5rem;
        font-size: .85rem;
        &:focus {
          background: #cdeeff;
        }
      }
      textarea {
        height: 150px;
        &:focus {
          background: #cdeeff;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.FamilyForm {
  .multiselect {
    min-height: 26px;
  }
  .multiselect__tags {
    border: 0;
    min-height: 26px;
    padding: 0px 40px 0 2px;
    font-size: .85rem;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 26px;
    font-size: .85rem;
  }
  .multiselect__select {
    height: 26px;
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
  .multiselect__placeholder {
    padding: .5rem 3px;
    margin: 0;
    color: #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// FamilyForm.vue?5af9906e